angular.module('pitch.playlist.pitch')
.controller('PitchPitchLandingCtrl', function ($scope, $rootScope, $controller, pitch, $timeout, Pitch) {

  angular.extend(this, $controller('PitchLandingCtrl', {$scope: $scope, pitch: pitch}));

  // workaround to get the button disabled while we load the data via xhr
  $scope.downloadableTracksCount = pitch.max_downloads + 1;

  $scope.playlistItemsLoader.onLoad(function(r) {
    var downloadableTracks = $scope.playlistItemsLoader.data.filter(function(track) {
      if (
        track.category_name &&
        track.category_name.toLowerCase().indexOf('pre-release') === -1 &&
        track.disabled === false
      ) {
        return track;
      }
    });

    $scope.downloadableTracksCount = downloadableTracks.length;
  });

  $scope.canDownloadAll = function(pitch) {
    return (pitch.max_downloads - pitch.downloads - $scope.downloadableTracksCount) >= 0;
  };

});



// WEBPACK FOOTER //
// ./src/PlaylistPitchClientBundle/Resources/js/angular/controllers/PitchPitchLandingCtrl.js